export const MUTATION_KEYS = {
    store_filters: 'store-filters',
    clear_filters: 'clear-filters',
    send_seen_talents: 'send-seen-talents',
    host_new_post: 'host-new-post',
    send_seen_posts: 'send-seen-posts',
    verify_18_age_with_gocam: 'verify-18-age-with-gocam'
}

export const QUERY_KEYS = {
    feedV3: 'feedV3',
    monthly_support: 'monthly-support',
    active_host: 'active-host',
    hosts_new_posts: 'hosts-new-posts'
}
